export default __webpack_public_path__ + "static/media/demo-doodle-4.bb03bec3.png";